import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { ImageCroppedEvent, ImageTransform } from 'ngx-image-cropper';
import { ManageProfileService } from '../../../modules/settings/manage-profile/manage-profile.service';
import { SharedDataService } from '../../service/shared-data/shared-data.service';
import { EnvironmentService } from '../../environment.service';
import { FormControl } from '@angular/forms';
import { StaffService } from 'src/app/modules/settings/staff/services/staff.service';
@Component({
  selector: 'app-upload-photo',
  templateUrl: './upload-photo.component.html',
  styleUrl: './upload-photo.component.scss',
})
export class UploadPhotoComponent implements OnInit {
  @Output() updateImageEvent = new EventEmitter<any>();
  profilePhoto: any = null;
  showFileDetails: boolean = true;
  selImage: any;
  imagePrepared: boolean = false;
  // imageChangedEvent: Event | null = null;
  imageChangedEvent: any;
  croppedImage: any;
  max: number = 2;
  min:number = -1
  zoom: number = 0;
  transform: ImageTransform = {};
  value = new FormControl(0); // Define FormControl instead of ngModel
  hideImgUpload: boolean = false;
  uploadedFile: any;
  enableImgDelete: boolean = false;
  constructor(
    private dialogRef: MatDialogRef<UploadPhotoComponent>,
    public manageProfileService: ManageProfileService,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public editImgData: any,
    private sharedDataService: SharedDataService,
    public envService: EnvironmentService,
    private staffService: StaffService
  ) {}
  ngOnInit() {
    if ((this.editImgData?.staffImg !== null && this.editImgData?.staffApiImg)||(this.editImgData?.staffImg !== null && this.editImgData?.orgApiImg)) {//in the second condition  staffImg stands for orgLogo and if valid organisation Logo url is present
     if(this.editImgData?.orgLogoImgError){
        this.enableImgDelete = false
      }
      else{
        this.enableImgDelete = true;
      }
      this.imagePrepared = false
      if(this.editImgData.imageUrl){
      }
    }
  } 

  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event?.file?.event;
    this.uploadedFile = event?.file?.event;
    if (this.imageChangedEvent) {
      this.enableImgDelete = true;
      this.imagePrepared = true;
    }
    if (event === 'error') {
      this.hideImgUpload = true;
    }
  }

  imageCropped(event: ImageCroppedEvent) {
    const blob = event.blob; // Get the cropped image as Blob
    this.croppedImage = event?.objectUrl;
    if (blob) {
      this.prepareImgObj(blob,'add')
    }
    // Create a File object from the Blob
  }

  prepareImgObj(blob:any,type:string){
    const file = new File([blob], 'cropped-image.png', { type: blob.type });

    // Create a DataTransfer object to hold the file
    const dataTransfer = new DataTransfer();
    dataTransfer.items.add(file); // Add the file to DataTransfer

    // Create a new input element
    const inputElement = document.createElement('input');
    inputElement.type = 'file';
    inputElement.files = dataTransfer.files; // Assign the FileList from DataTransfer
    // Dispatch the change event with the input element as the target
    const changeEvent = new Event('change', {
      bubbles: true,
      cancelable: true,
    });

    // Set the target property of the event to the inputElement using a closure
    Object.defineProperty(changeEvent, 'target', {
      writable: false,
      value: inputElement,
    });
    Object.defineProperty(changeEvent, 'srcElement', {
      writable: false,
      value: inputElement,
    });

    // Dispatch the change event on the input element
    inputElement.dispatchEvent(changeEvent);
    if(type === 'add'){
     this.uploadedFile = changeEvent;
    }
  }

  cancelForm() {
    this.dialogRef.close();
  }

  onSliderChange(value: any) {
    const sliderValue = this.value.value ?? 0; // Get value from FormControl
    this.zoom = sliderValue;
    let scale = sliderValue >= 0 ? sliderValue + 1 : 1 - (sliderValue / this.max) * -1;
    scale = Math.max(scale, 0.5)
    this.transform = { scale };
  }

  uploadPhoto() {
    let imgUploadResult;
    const formData: any = new FormData();
    if (this.uploadedFile) {
      // formData.append('image', this.uploadedFile.target.files[0]);
      imgUploadResult = {
        result: 'success',
        formData: this.uploadedFile.target.files[0],
        croppedImage: this.croppedImage,
      };
      this.updateImageEvent.emit(imgUploadResult);
      this.dialogRef.close(imgUploadResult);
    }
  }
  deleteImage() {
    // Reset all related variables to their default state
    this.imageChangedEvent = null; // Remove the selected image
    this.enableImgDelete = false;
    this.uploadedFile = null; // Clear uploaded file
    this.imagePrepared = false; // Disable Save button
    this.hideImgUpload = false; // Show the upload area again
    this.transform = { scale: 1 }; // Reset zoom/scale
    this.editImgData.imageUrl = ''
    if (this.editImgData?.staffApiImg) {
      const deleteImage$ = this.editImgData?.module === 'staff' 
      ? this.staffService.deleteStaffImage(this.editImgData?.staffId)
      : this.sharedDataService.deleteStaffImg();
    
    deleteImage$.subscribe({
      next: (data: any) => {
        if (data.status === 204) {
          this.editImgData.staffImg = null;
          this.updateImageEvent.emit({ imgDeleted: true });
        }
      },
      error: (error: any) => {},
    });
    }
    if (this.editImgData?.orgApiImg) {// to inform the org image edit component  about the delete operation. The deletion is done in that component.
      this.updateImageEvent.emit({ imgDelete: true });
    }
  }
  get title(): string {
    return this.editImgData?.title || 'toolbar.content.profile.action.edit_profile_pic';
  }
}
